import React from "react";

export default (props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 6.241 6.241"
    enableBackground="new 0 0 6.241 6.241"
  >
    <path
      fill={props.color}
      d="m4.46,4.808c-0.341,0.299-0.785,0.448-1.334,0.448-0.541,0-0.98-0.15-1.314-0.45-0.336-0.3-0.504-0.731-0.504-1.293v-3.513h0.422v3.51c0,0.441 0.129,0.782 0.387,1.023 0.258,0.24 0.594,0.36 1.01,0.36 0.422,0 0.766-0.119 1.029-0.358 0.266-0.24 0.398-0.582 0.398-1.024v-3.511h0.418v3.512c8.88178e-16,0.565-0.17,0.996-0.512,1.296zm-3.259,1.433v-0.487h3.84v0.486h-3.84v0.001z"
    />
  </svg>
);
